export type InAppBrowser = "tiktok" | "instagram" | "facebook" | "snapchat" | "linkedin" | "webview";

const APP_PATTERNS: Array<[InAppBrowser, RegExp]> = [
  ["tiktok", /musical_ly|BytedanceWebview|ByteLocale|TikTok|trill_/i],
  ["instagram", /Instagram/i],
  ["facebook", /FBAN|FBAV|FB_IAB|FBIOS/i],
  ["snapchat", /Snapchat/i],
  ["linkedin", /LinkedInApp/i],
];

const APP_LABELS: Record<InAppBrowser, string> = {
  tiktok: "the TikTok app",
  instagram: "Instagram",
  facebook: "Facebook",
  snapchat: "Snapchat",
  linkedin: "LinkedIn",
  webview: "this in-app browser",
};

/**
 * Identify embedded app browsers, where Google blocks OAuth sign-in
 * (`disallowed_useragent`). Ad clicks from TikTok open in one of these.
 * Safari, Chrome, Firefox and installed home-screen apps return null.
 */
export function detectInAppBrowser(
  userAgent = typeof navigator === "undefined" ? "" : navigator.userAgent,
  standalone = typeof navigator !== "undefined" && (navigator as any).standalone === true,
): InAppBrowser | null {
  for (const [name, pattern] of APP_PATTERNS) {
    if (pattern.test(userAgent)) return name;
  }
  // Android System WebView marks itself with "; wv)". iOS WKWebView omits the
  // "Safari/" token that Safari, Chrome (CriOS) and Firefox (FxiOS) send.
  if (/Android/i.test(userAgent) && /; wv\)/.test(userAgent)) return "webview";
  if (!standalone && /iPhone|iPad|iPod/i.test(userAgent) && /AppleWebKit/i.test(userAgent) && !/Safari\//i.test(userAgent)) {
    return "webview";
  }
  return null;
}

export function inAppBrowserLabel(browser: InAppBrowser): string {
  return APP_LABELS[browser];
}
